<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Users</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_USER_WRITE']" class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add User
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">

    <!--    <div class="d-flex justify-content-end align-items-center mb-3">-->
    <!--      <button class="btn btn-primary fw-bold" onclick="location.href='createnewuser.html'"><i-->
  <!--        class="bi bi-person-plus"></i> Create New User-->
<!--      </button>-->
<!--    </div>-->

<!-- Table of users -->
<div class="table-responsive">
  <table class="table table-hover table-striped align-middle">
    <thead>
      <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
        <th>Picture</th>
        <th tableSorterHeader="firstname">First Name</th>
        <th tableSorterHeader="lastname">Last Name</th>
        <th tableSorterHeader="email">Email</th>
        <th tableSorterHeader="enabled">Status</th>
        <th tableSorterHeader="loggedAt">Last Login</th>
        <th>Role</th>
        <th>Manager</th>
        <th class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      @for (user of users; track user) {
        <tr>
          <td>
            <div class="profile-picture">
              @if (user.image) {
                <img [ngSrc]="imageService.getImageUrl(user.image, 128, 128)" alt="" fill class="rounded">
              }
            </div>
          </td>
          <td>{{ user.firstname }}</td>
          <td>{{ user.lastname }}</td>
          <td>{{ user.email }}</td>
          <td>
            @if (user.enabled) {
              <span class="badge bg-success">Enabled</span>
            }
            @if (!user.enabled) {
              <span class="badge bg-danger">Disabled</span>
            }
          </td>
          <td>{{ user.loggedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>{{ getRole(user) }}</td>
          <td>
            @if (user.accountManager) {
              <span class="badge bg-primary me-1">Account Manager</span>
            }
            @if (user.teamManager) {
              <span class="badge bg-secondary">Team Manager</span>
            }
          </td>
          <td class="text-center">
            <a class="btn btn-outline-primary btn-sm" [routerLink]="[user.id]"><i
            class="bi bi-pencil me-1"></i>Edit
          </a>
          <button *isGranted="['ROLE_API_USER_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(user)"><i
          class="bi bi-trash"></i></button>
        </td>
      </tr>
    }
  </tbody>
</table>

<app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
</div>
</div>
</div>
